<template>
  <div>
    <sweet-modal
      overlay-theme="dark"
      hide-close-button
      ref="modal"
      enable-mobile-fullscreen
      class="no-padding-content"
      @close="modalClosed"
      :width="modalWidth"
    >
      <div class="bg-modal-gradient flex justify-between items-center p-6">
        <div class="text-white text-3xl">
          <i class="fa fa-key mr-4"></i> View key document
        </div>
        <div>
          <button
            type="button"
            class="text-white text-2xl hover:text-grey"
            @click="$refs.modal.close()"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>

      <div class="flex flex-col md:flex-row">
        <div
          class="iframe-container flex-1 mr-2"
          v-if="
            selectedKeyDocument.files != undefined &&
            selectedKeyDocument.files.length > 0 &&
            !edit
          "
        >
          <div
            class="justify-center items-center h-screen flex flex-col"
            v-if="previewLoading"
          >
            <i class="fa fa-circle-notch fa-spin"></i>
            loading
          </div>
          <iframe
            :src="previewUrl"
            frameborder="0"
            style="overflow: hidden; height: 100%; width: 100%"
            height="100%"
            width="100%"
            class="iframe"
          ></iframe>
        </div>

        <!-- view -->
        <div
          class="flex-1 p-6 w-full text-left flex flex-col justify-space-between"
          v-if="!edit"
        >
          <div>
            <div class="flex flex-col-reverse md:flex-row">
              <p class="text-xl md:text-2xl font-bold">
                {{ selectedKeyDocument.title }}
              </p>
            </div>
            <div class="flex flex-col my-4">
              <div class="flex flex-col">
                <p class="text-grey-darker w-48 mb-2">
                  <i class="fas fa-comment mr-2"></i>Description
                </p>
                <p class="mt-2 md:mt-0">
                  {{ selectedKeyDocument.description }}
                </p>
              </div>
              <div class="flex mt-4 flex-col">
                <p class="text-grey-darker w-48 mb-2">
                  <i class="fas fa-user mr-2"></i>Created by
                </p>
                <p class="mt-2 md:mt-0">
                  {{
                    selectedKeyDocument.user &&
                    selectedKeyDocument.user.first_name
                      ? selectedKeyDocument.user.first_name
                      : ""
                  }}
                  {{
                    selectedKeyDocument.user &&
                    selectedKeyDocument.user.last_name
                      ? selectedKeyDocument.user.last_name
                      : ""
                  }}
                  <span class="text-sm"
                    >(
                    {{
                      formatDate(selectedKeyDocument.created_at, "MMM D, YYYY")
                    }}
                    )</span
                  >
                </p>
              </div>
              <div class="flex mt-4">
                <div
                  class="w-full text-left"
                  v-if="
                    selectedKeyDocument.files != undefined &&
                    selectedKeyDocument.files.length > 0
                  "
                >
                  <label class="text-grey-darker">
                    <i class="fas fa-file mr-3"></i>File Attached:
                  </label>
                  <div class="mt-2">
                    <p
                      v-for="file in selectedKeyDocument.files"
                      :key="file.id"
                      class="mb-1 flex items-center"
                    >
                      <button
                        type="button"
                        class="text-red mr-2 block"
                        v-if="canAccess()"
                        @click.prevent="removeFile(file)"
                      >
                        <i class="fa fa-times-circle"></i>
                      </button>
                      <button @click="downloadFile(file)" class="mr-2 text-blue" type="button">
                        <i class="fa fa-download"></i>
                      </button>
                      <a
                        href="#"
                        @click.prevent="previewFile(file)"
                        class="text-black text-sm underline block hover:text-brand"
                        >{{ file.filename }}</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-between items-center mt-auto pt-6" v-if="canAccess()">
            <button
              class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark self-end"
              type="button"
              @click.prevent="edit = true"
              v-if="!edit"
            >
              <i class="fa fa-edit mr-2"></i> Edit
            </button>
            <button
              class="border border-red bg-white text-red text-sm font-medium py-2 px-4 rounded hover:bg-red hover:text-white self-end"
              type="button"
              @click="$refs.deleteKeyDocument.open()"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>

        <!-- edit -->
        <form
          v-if="edit"
          @submit.prevent="saveKeyDocument"
          data-vv-scope="edit-key-document"
          ref="drop_target"
          class="p-6 flex-1"
          enctype="multipart/form-data"
        >
          <div class="w-full text-left my-4">
            <div class="flex justify-between">
              <label class="font-medium"
                >Title <span class="text-red">*</span></label
              >
              <label class="text-red text-sm font-medium"
                >* Required info</label
              >
            </div>
            <input
              type="text"
              class="w-full h-10 border rounded px-3 mt-1"
              v-model="selectedKeyDocument.title"
              v-validate="'required'"
              name="title"
              tabindex="1"
              :class="{ 'border-red': errors.has('edit-key-document.title') }"
            />
            <div
              v-show="errors.has('edit-key-document.title')"
              class="text-red text-sm mt-1"
            >
              {{ errors.first("edit-key-document.title") }}
            </div>
          </div>
          <div class="w-full text-left my-4">
            <label class="font-medium">Description</label>
            <textarea
              class="w-full border rounded py-2 px-3 mt-1"
              v-model="selectedKeyDocument.description"
              name="description"
              tabindex="1"
              :class="{
                'border-red': errors.has('edit-key-document.description'),
              }"
            ></textarea>
            <div
              v-show="errors.has('edit-key-document.description')"
              class="text-red text-sm mt-1"
            >
              {{ errors.first("edit-key-document.description") }}
            </div>
          </div>

          <div class="flex my-4">
            <div
              class="w-full text-left"
              v-if="
                selectedKeyDocument.files != undefined &&
                selectedKeyDocument.files.length > 0
              "
            >
              <label class="text-grey-darker">
                <i class="fas fa-file mr-3"></i>File Attached:
              </label>
              <div class="mt-2">
                <p
                  v-for="file in selectedKeyDocument.files"
                  :key="file.id"
                  class="mb-1 flex items-center"
                >
                  <button
                    type="button"
                    class="text-red mr-2 block"
                    v-if="canAccess()"
                    @click.prevent="removeFile(file)"
                  >
                    <i class="fa fa-times-circle"></i>
                  </button>
                  <a
                    href="#"
                    class="text-black text-sm underline block hover:text-brand"
                    >{{ file.filename }}</a
                  >
                </p>
              </div>
            </div>
          </div>

          <file-upload
            ref="fileUpload"
            v-show="!vault.storage_exceeded"
          ></file-upload>

          <div
            v-if="vault.storage_exceeded"
            class="mt-4 bg-red-lightest border border-dashed w-full p-1 border-red text-sm"
          >
            Vault Storage Exceeded, uploading is not allowed
          </div>

          <div class="mt-6 flex justify-between items-center">
            <div>
              <button
                class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark"
                type="submit"
              >
                <i class="fa fa-save mr-2"></i> Update
              </button>
              <button
                class="border border-grey bg-white text-grey-darker text-sm font-medium py-2 px-4 rounded hover:bg-grey-lightest ml-2"
                type="button"
                @click.prevent="edit = false"
              >
                Cancel
              </button>
            </div>
            <div>
              <button
                class="border border-red bg-white text-red text-sm font-medium py-2 px-4 rounded hover:bg-red hover:text-white"
                type="button"
                @click.prevent="$refs.deleteKeyDocument.open()"
                v-if="canAccess()"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </sweet-modal>

    <confirm-dialog
      ref="deleteKeyDocument"
      title="Delete this key document?"
      body="This cannot be undone."
      action-label="Delete"
      @confirm="deleteKeyDocument"
    ></confirm-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmDialog from "../../../ConfirmDialog.vue";

import FileUpload from "../FileUpload.vue";

export default {
  name: "ViewKeyDocument",

  props: ["selectedKeyDocument", "vault"],

  components: {
    ConfirmDialog,
    FileUpload,
  },

  data() {
    return {
      previewLoading: false,

      previewUrl: "",

      edit: false,
    };
  },

  methods: {
    saveKeyDocument() {
      this.$validator.validateAll("edit-key-document").then((result) => {
        if (result) {
          this.$emit("processing", true);

          // build form data
          const formData = new FormData();
          formData.append("title", this.selectedKeyDocument.title);
          formData.append("description", this.selectedKeyDocument.description);

          const files = this.$refs.fileUpload.getFiles();
          const vaultFiles = this.$refs.fileUpload.getVaultFiles();
          files.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
          });
          vaultFiles.forEach((file, index) => {
            formData.append(`vault_files[${index}]`, file.id);
          });

          // send API request
          axios
            .post(
              `api/vaults/${this.$route.params.vault_id}/key-documents/${this.selectedKeyDocument.id}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((response) => {
              console.log(response);
              if (response && response.data) {
                const data = response.data;
                if (data.success) {
                  this.$noty.success(data.message);
                }
              }
              this.$emit("getKeyDocuments");
              this.$emit("processing", false);
              this.$refs.modal.close();
            })
            .catch(({ response }) => {
              let data = response.data;
              if (!data.success) {
                this.$emit("processing", false);
                this.$noty.error(data.message);
              }
            });
        }
      });
    },

    modalClosed() {
      this.edit = false;
    },

    deleteKeyDocument() {
      this.$refs.deleteKeyDocument.close();

      this.$emit("processing", true);

      axios
        .delete(
          `api/vaults/${this.selectedKeyDocument.vault_id}/key-documents/${this.selectedKeyDocument.id}`
        )
        .then(({ data }) => {
          this.$noty.success(data.message);
          this.$emit("getKeyDocuments");
          this.$refs.modal.close();
          this.$emit("processing", false);
        })
        .catch(({ response }) => {
          let data = response.data;
          if (!data.success) {
            this.$noty.error(data.message);
          }
          this.$emit("processing", false);
        });
    },

    removeFile(file) {
      axios
        .delete(
          `api/vaults/${this.selectedKeyDocument.vault_id}/key-documents/${this.selectedKeyDocument.id}/files/${file.id}`
        )
        .then(({ data }) => {
          this.$noty.success(data.message);
          this.selectedKeyDocument.files.splice(
            _.findIndex(this.selectedKeyDocument.files, ["id", file.id]),
            1
          );
          if (this.selectedKeyDocument.files.length > 0) {
            this.previewFile(this.selectedKeyDocument.files[0]);
          }
          this.$emit("getKeyDocuments");
        })
        .catch(({ response }) => {
          let data = response.data;
          if (!data.success) {
            this.$noty.error(data.message);
          }
        });
    },

    downloadFile(file) {
      axios
        .get(`api/vaults/${file.vault_id}/files/${file.id}/download-path`, {
          params: {
            is_download: 1,
          },
        }).then(({ data }) => {
          window.open(data.url, '_blank');
        })
    },
    
    previewFile(file) {
      this.previewLoading = true;
      axios
        .get(`api/vaults/${file.vault_id}/files/${file.id}/download-path`, {
          params: {
            is_download: 0,
          },
        })
        .then(({ data }) => {
          this.previewLoading = false;
          if (/\.pdf$/i.test(file.filename)) {
            this.previewUrl =
              `/pdf_viewer_3/viewer.html?file=` + encodeURIComponent(data.url);
          } else {
            let office_file_exts = [
              "doc",
              "docx",
              "dotx",
              "odt",
              "ppt",
              "pptx",
              "odp",
              "xls",
              "xlsx",
              "ods",
            ];
            let file_ext_matches = file.filename.match(/[^.]+$/);
            if (file_ext_matches.length > 0) {
              let file_ext = file_ext_matches[0];
              if (office_file_exts.indexOf(file_ext) >= 0) {
                let baseURL = "https://docs.google.com/gview?url=";
                if(file_ext == "doc") {
                  baseURL = "https://view.officeapps.live.com/op/embed.aspx?src=";
                }
                // old URL: https://docs.google.com/viewer?url=
                this.previewUrl =
                  baseURL +
                  encodeURIComponent(data.url) +
                  "&embedded=true&headers=true";
              } else {
                this.previewUrl = data.url;
              }
            } else {
              this.previewUrl = data.url;
            }
          }
        });
    },

    canAccess() {
      if (_.includes(["userA", "userB"], this.role)) {
        return true;
      }

      return false;
    },

    formatDate(date, format) {
      let d = moment(date);
      return d.format(format);
    },
  },

  watch: {
    selectedKeyDocument(value) {
      if (value.files && value.files.length > 0) {
        this.previewFile(value.files[0]);
      }
    },
  },

  computed: {
    ...mapGetters({
      role: "getUserRole",
    }),

    modalWidth() {
      if (this.edit) {
        return "50%";
      }

      if (this.$mq == "mobile") {
        return "100%";
      } else {
        if (
          this.selectedKeyDocument.files &&
          this.selectedKeyDocument.files.length > 0
        ) {
          return "80%";
        }
      }
      return "50%";
    },
  },
};
</script>

<style scoped>
button:focus {
  outline: none;
}

.no-padding-content .sweet-content .conversation {
  height: 400px;
}

.iframe-container {
  position: relative;
  padding-bottom: 56.25%; /* proportion value to aspect ratio 16:9 (9 / 16 = 0.5625 or 56.25%) */
  height: 0;
  overflow: hidden;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .iframe-container {
    height: 75vh;
  }
}
</style>

